import React from 'react';

interface KpiCardProps {
  title: string;
  value: string | number;
  sub?: string;
  icon: React.ElementType;
  /** Tailwind bg class for the icon bubble, e.g. "bg-pos-primary" */
  accent: string;
}

export const KpiCard: React.FC<KpiCardProps> = ({
  title,
  value,
  sub,
  icon: Icon,
  accent,
}) => (
  <div className="rounded-2xl border border-gray-200 bg-white p-5">
    <div className="flex items-start justify-between">
      <div className="min-w-0 flex-1">
        <p className="truncate text-xs text-gray-500">{title}</p>
        <p className="mt-1 text-2xl font-bold text-gray-900">
          {typeof value === 'number' ? value.toLocaleString() : value}
        </p>
        {sub && <p className="mt-0.5 truncate text-xs text-gray-400">{sub}</p>}
      </div>
      <div className={`ml-3 flex-shrink-0 rounded-xl p-2.5 ${accent}`}>
        <Icon size={18} className="text-white" />
      </div>
    </div>
  </div>
);
